import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'app-nav-button',
  templateUrl: './nav-button.component.html',
  styleUrls: ['./nav-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavButtonComponent implements OnInit {
  @Input({ required: true }) icon?: string;
  @Input() hideBackground = false;
  @Input() size: 'large' | 'medium' = 'large';
  @Output() clickEvent = new EventEmitter<void>();

  sizeCss = '--icon-x-large';

  ngOnInit(): void {
    this.sizeCss = this.size === 'large' ? '--icon-x-large' : '--icon-medium';
  }

  onClick(): void {
    this.clickEvent.emit();
  }
}
